import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.insistent_resize(this.element);
  }

  resize(event) {
    this.insistent_resize(this.element)
  }

  insistent_resize(el) {
    var minHeight = el.getAttribute("data-min-height") || 76;
    el.style.height = '5px';
    if (el.scrollHeight > 0) {
      el.style.overflowY = 'hidden'; // safari bug
      el.style.height = Math.max(el.scrollHeight, minHeight) + 'px';
    } else {
      setTimeout(() => { this.insistent_resize(el) }, 100);
    }
  }
}
